import { ApiClientError, api } from './api';

export async function hasAccountSession(
  getAccount: typeof api.getAccount = api.getAccount,
): Promise<boolean> {
  try {
    await getAccount();
    return true;
  } catch (reason) {
    if (reason instanceof ApiClientError && reason.status === 401) return false;
    throw reason;
  }
}
